import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-base/base-flow-task/todo-page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const completeTask = params => request({
  url: '/api/mcc-base/base-flow-task/complete-task',
  method: 'post',
  data: params,
})

const completeTaskList = params => request({
  url: '/api/mcc-base/base-flow-task/complete-task-List',
  method: 'post',
  data: params,
})

const queryNoticeList = (current, size, params) => request({
  url: '/api/mcc-base/system/receiveNotice/queryNoticeList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const noticeMarkRead = params => request({
  url: '/api/mcc-base/system/receiveNotice/updateReadStatusByIds',
  method: 'post',
  params: { ...params },
})

const noticeList = (current, size, params) => request({
  url: '/api/mcc-base/system/receiveNotice/queryNoticeList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

// 发送通知
const noticeSend = params => request({
  url: '/api/mcc-staff/processfield/sendSelfAppraisalNotice',
  method: 'post',
  data: params,
})

const noticeAllList = (current, size, params) => request({
  url: '/api/mcc-base/system/receiveNotice/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const noticeAdd = params => request({
  url: '/api/mcc-base/system/notice/save',
  method: 'post',
  data: params,
})

const noticeUpdate = (params, headers) => request({
  url: '/api/mcc-base/system/notice/update',
  method: 'post',
  headers,
  data: params,
})

const noticeRemove = ids => request({
  url: '/api/mcc-base/system/notice/delete',
  method: 'post',
  params: {
    ids,
  },
})

const noticeView = noticeId => request({
  url: '/api/mcc-base/system/receiveNotice//queryNoticeDetailById',
  method: 'get',
  params: {
    noticeId,
  },
})

const readAll = params => request({
  url: '/api/mcc-base/system/receiveNotice/readAllByType',
  method: 'post',
  params: { ...params },
})

const processKeyAndFormName = params => request({
  url: '/api/mcc-base/base/templateForm/processKeyAndFormName',
  method: 'get',
  params: { ...params },
})

const exportExcel = params => request({
  url: '/api/mcc-base/system/receiveNotice/excel',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})

export default {
  getList,
  completeTask,
  completeTaskList,
  queryNoticeList,
  noticeMarkRead,
  noticeAdd,
  noticeUpdate,
  noticeRemove,
  noticeList,
  noticeView,
  readAll,
  processKeyAndFormName,
  noticeAllList,
  noticeSend,
  exportExcel,
};
